// extracted by mini-css-extract-plugin
export default {"UnInheritLibraryDialog":"UnInheritLibraryDialog_UnInheritLibraryDialog__1+a6p"};